import React from "react";
import { Box, FormControlLabel, Switch, Typography } from "@mui/material";

/**
 * Switches an accounts-receivable report between the whole open book
 * ("as of today") and the selected reporting period.
 *
 * Defaults to the open book: invoice dates are not the same as service dates,
 * so a single-month window would hide invoices that are still unpaid.
 */
const ReportScopeToggle = ({ openOnly, onChange, openLabel, periodLabel }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
        px: { xs: 0, sm: "0.5rem" },
        mb: 1.5,
      }}
    >
      <FormControlLabel
        control={
          <Switch
            size="small"
            checked={openOnly}
            onChange={(event) => onChange(event.target.checked)}
          />
        }
        label={
          <Typography variant="body2" fontWeight={600}>
            {openOnly ? openLabel : periodLabel}
          </Typography>
        }
      />
      <Typography variant="caption" color="text.secondary">
        {openOnly
          ? "Every unpaid invoice, regardless of invoice month."
          : "Limited to the period selected in the filter bar."}
      </Typography>
    </Box>
  );
};

export default ReportScopeToggle;
